

export const txtCatNames = [
  "Halki", "Max", "Tiger", "Luna", "Bella", "Molly", "Daisy", "Maggie",
  "Sophie", "Stella", "Lily", "Penny", "Zoe", "Cleo", "Mia", "Lola",
  "Ruby", "Rosie", "Pepper", "Ginger", "Mittens", "Smokey", "Shadow", "Simba",
  "Oliver", "Leo", "Milo", "Oscar", "Jasper", "Toby", "Felix", "Simon", "Buddy", "Sam",
  "Rusty", "Rex", "Mickey", "Romeo", "Sunny", "Patches"
].sort((a, b) => a.localeCompare(b));

export const txtPronounDropdown = ["He/Him", "She/Her", "They/Them"];
export const txtPronoun1 = ["he", "she", "they"];
export const txtPronoun2 = ["his", "her", "their"];
export const txtPronoun3 = ["his", "hers", "theirs"];
export const txtPatternDropdown = ["black", "grey", "calico"];